import React from 'react';

const facilities = [
  {
    id: 1,
    title: 'Dedicated Company',
    description: 'Our company in Karachi is extremely dedicated, and we put in all our efforts to present quality services and the best results to our clients.',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M6 3h12l4 6-10 12L2 9z" />
        <path d="M11 3v18" />
        <path d="M2 9h20" />
      </svg>
    )
  },
  {
    id: 2,
    title: 'Advanced Technology',
    description: 'Modern infrastructure and latest technologies to maintain optimal performance and provide adaptable solutions',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
        <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
      </svg>
    )
  },
  {
    id: 3,
    title: 'Results Driven',
    description: 'Tested and proven strategies and measurable outcomes that can exceed client expectations and industry standards',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="4" y="2" width="16" height="20" rx="2" ry="2" />
        <path d="M9 22v-4h6v4" />
        <path d="M8 6h.01" />
        <path d="M16 6h.01" />
      </svg>
    )
  },
  {
    id: 4,
    title: 'Expert Team',
    description: 'Highly skilled professionals with extensive experience in BPO, IT, digital marketing, and web development',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="3" />
        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
      </svg>
    )
  }
];

function OurFacilitiesSection() {
  return (
    <section className="facilities-section">
      <div className="container">
        
        {/* Header */}
        <div className="facilities-header">
          <div className="facilities-badge-row">
            <span className="facilities-badge">Our Facilities</span>
            <span className="facilities-badge-line"></span>
          </div>
          <h2 className="facilities-title">
            What Sets Our Business Solutions<br />Apart From Others?
          </h2>
        </div>

        {/* Premium Grid UI */}
        <div className="facilities-grid">
          {facilities.map((item, index) => (
            <div key={item.id} className="facility-card">
              <div className="facility-card-header">
                <span className="facility-number">0{index + 1}</span>
                <div className="facility-icon-wrapper">
                  {item.icon}
                </div>
              </div>
              <div className="facility-card-body">
                <h3 className="facility-card-title">{item.title}</h3>
                <p className="facility-card-desc">{item.description}</p>
              </div>
              <div className="facility-card-footer">
                <span className="facility-accent-line"></span>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}

export default OurFacilitiesSection;
